import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    projects: [],
    selectedProject: null,
    isLoading: false,
    error: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0,
    },
};

const projectSlice = createSlice({
    name: "project",
    initialState,
    reducers: {
        setProjects: (state, action) => {
            state.projects = action.payload;
        },
        setSelectedProject: (state, action) => {
            state.selectedProject = action.payload;
        },
        addProject: (state, action) => {
            state.projects.unshift(action.payload);
        },
        updateProjectInList: (state, action) => {
            const index = state.projects.findIndex(p => p._id === action.payload._id);
            if (index !== -1) {
                state.projects[index] = action.payload;
            }
            if (state.selectedProject?._id === action.payload._id) {
                state.selectedProject = action.payload;
            }
        },
        removeProject: (state, action) => {
            state.projects = state.projects.filter(p => p._id !== action.payload);
            if (state.selectedProject?._id === action.payload) {
                state.selectedProject = null;
            }
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setPagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
    },
});

export const {
    setProjects,
    setSelectedProject,
    addProject,
    updateProjectInList,
    removeProject,
    setLoading,
    setError,
    setPagination,
} = projectSlice.actions;

export const ProjectReducer = projectSlice.reducer;